module.exports = __webpack_public_path__ + "static/img/bg@2x.9017081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/bg@2x.png
// module id = ePe1
// module chunks = 70